import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue'
import { getOptimalFlexRowCol } from '@/helpers/layout.helper'
import { useElementSize } from '@vueuse/core'

export default /*#__PURE__*/_defineComponent({
  __name: 'CompartmentGrid',
  props: {
  nCompartments: {
    type: Number,
    required: true,
  },
  isFocused: {
    type: Boolean,
    default: false,
  },
  isBarHidden: {
    type: Boolean,
    default: false,
  },
  isRoomControlSmall: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

_useCssVars(_ctx => ({
  "562c315a": (nRows.value),
  "34eeefba": (nColumns.value)
}))

const props = __props

const othersRef = ref<HTMLElement | null>(null)
const { width: elementWidth } = useElementSize(othersRef)
const nOthers = computed(() => props.nCompartments)

const flexValue = computed(() => {
  const [row, col] = getOptimalFlexRowCol(
    nOthers.value,
    props.isFocused,
    elementWidth.value < 1000 ? 'md' : undefined,
  )
  return {
    nRows: row,
    nCols: col,
  }
})

const nColumns = computed(() => flexValue.value.nCols)
const nRows = computed(() => flexValue.value.nRows)

const isOnlyOnceChild = computed(() => props.nCompartments === 1 && !props.isFocused)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "othersRef",
    ref: othersRef,
    class: _normalizeClass(["compartment-grid", { '-once-child': isOnlyOnceChild.value }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})